import React, { useState } from 'react'
import { IconButton } from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import { useAccountCreationCompletionStyles } from '../../hooks/useAccountCreationCompletionStyles'

const maskPassword = password => '*'.repeat(Math.max(password.length, 8))

export default function AccountCreationCompletion({ organization, profile, password }) {
  const classes = useAccountCreationCompletionStyles()
  const [showPassword, setShowPassword] = useState(false)
  const login = profile.email || profile.phoneNumber || ''
  const loginLabel = profile.email ? 'Email' : 'Phone Number'

  return (
    <div className={classes.container}>
      <div className={classes.instructions}>
        <p>Your account has been created successfully.</p>
        <p>{organization.name} will review your volunteer account and let you know whether it has been approved.</p>
        <p>
          <span className={classes.saveCredentials}>Please save your email address and password.</span>
        </p>
        <p>You'll use them to log in to Civic Champs once your account is approved.</p>
      </div>

      <div className={classes.credentialsBox}>
        <h2 className={classes.credentialsHeading}>Your Civic Champs Credentials</h2>
        <div className={classes.field}>
          <span className={classes.fieldLabel}>{loginLabel}</span>
          <div className={classes.fieldValue}>{login}</div>
        </div>
        <div className={classes.field}>
          <span className={classes.fieldLabel}>Password</span>
          <div className={classes.passwordRow}>
            <span className={classes.passwordValue}>{showPassword ? password : maskPassword(password)}</span>
            <IconButton
              className={classes.visibilityButton}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              onClick={() => setShowPassword(value => !value)}
              onMouseDown={event => event.preventDefault()}
              edge="end"
              size="small"
            >
              {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  )
}
